module.exports = __webpack_public_path__ + "static/img/hero.2d275e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hero.jpg
// module id = VTGo
// module chunks = 1